import { useMutation } from "@apollo/client";

import { RedeemGiftCardDocument } from "../../__generated__/graphql";

export function useRedeemGiftCard() {
  return useMutation(RedeemGiftCardDocument, {
    update(cache) {
      cache.evict({ fieldName: "creditAccountById" });
      cache.evict({ fieldName: "creditAccountTransactionsByFilters" });
      // The redeemed card moves tabs in the gift card history, so drop those lists too.
      cache.evict({ fieldName: "giftCardsByFilters" });
      cache.evict({ fieldName: "giftCard" });
      cache.gc();
    },
    refetchQueries: ["ClientCreditAccounts"],
  });
}
